import React from 'react'
import './AcceptModal.css'
import closeIcon from '../Assets/Icons/close.png'

export default function AcceptModal({ setOpen, onConfirm, guestName, showMealChoices = true }) {
    const handleConfirm = () => {
        onConfirm()
        setOpen(false)
    }

    return (
        <div className="accept-modal-overlay">
            <div className="accept-modal-content">
                <img
                    src={closeIcon}
                    alt="Close"
                    className="accept-modal-close"
                    onClick={() => setOpen(false)}
                />

                <h3 className="accept-modal-title">
                    We're so excited you can join us!
                </h3>

                {guestName && (
                    <p className="accept-modal-guest-name">
                        Accepting for: {guestName}
                    </p>
                )}

                <p className="accept-modal-message">
                    {showMealChoices
                        ? "To help us plan the perfect day, we'll need a few more details from you, including your meal choices and any plus one information."
                        : "To help us plan the perfect day, we'll need a few more details from you, including any plus one information."}
                </p>

                <button
                    onClick={handleConfirm}
                    className="accept-confirm-btn"
                >
                    Continue
                </button>
            </div>
        </div>
    )
}

